<template>
  <div>
    <div class="table_card">
      <div class="table_card__head">
        <v-layout row wrap>
          <v-flex lg12>
            <p class="table_card__head--title">
              Edición de counter
            </p>
            <v-breadcrumbs class="breadcums">
              <v-icon slot="divider">chevron_right</v-icon>
              <v-breadcrumbs-item
                @click="$router.push({name: 'access'})"
                class="breadcums__option"
              >
                Resumen de accesos
              </v-breadcrumbs-item>
              <v-breadcrumbs-item
                @click="$router.push({name: 'counter_index'})"
                class="breadcums__option"
              >
                Counters
              </v-breadcrumbs-item>
              <v-breadcrumbs-item
                disabled
                class="breadcums__disable"
              >
                Editar counter
              </v-breadcrumbs-item>
            </v-breadcrumbs>
          </v-flex>
        </v-layout>
      </div>
      <div class="table_card__body">
        <v-layout row wrap>
          <v-flex xs12 row>
            <v-form onSubmit="return false;" ref="form" v-model="valid" lazy-validation>
              <v-layout row wrap
                style="background-color: #fff; padding: 0px;"
              >
                <v-flex xs5 style="padding: 8px">
                  <v-text-field
                    v-model="counter.attributes.name"
                    label="Nombre"
                    required
                    placeholder="Nombre"
                    :rules="[rules.required, rules.name]"
                    counter="25"></v-text-field>
                </v-flex>
                <v-flex
                  xs1
                  style="padding: 8px">
                </v-flex>
                <v-flex
                  xs5
                  style="padding: 8px 0px">
                  <v-text-field
                    v-model="counter.attributes.last_name"
                    label="Apellidos"
                    required
                    placeholder="Apellidos"
                    :rules="[rules.required, rules.name]"
                    counter="25"></v-text-field>
                </v-flex>

                <v-flex
                  xs5
                  style="padding: 8px">
                  <v-text-field
                    v-model="counter.attributes.email"
                    label="Correo electrónico"
                    required
                    placeholder="Correo electrónico"
                    :rules="[rules.required, rules.email, rules.affair]"
                    counter="50"></v-text-field>
                </v-flex>
                <v-flex
                  xs1
                  style="padding: 8px">
                </v-flex>
                <v-flex xs5>
                  <v-text-field
                    v-model="counter.attributes.rut"
                    style="margin-top:10px"
                    label="Cédula"
                    required
                    placeholder="Cédula"
                    @keypress="isRutValid($event)"
                    :rules="[rules.required, rules.affair,rules.rut]"
                    counter="20">
                  </v-text-field>
                </v-flex>

                <v-flex xs5>
                  <v-select
                    style="margin-top:10px"
                    label="Locación"
                    :items="locationArray"
                    item-text="name"
                    item-value="id"
                    v-model="counter.attributes.location_id"
                    :rules="[rules.requiredSelect]"
                    clearable
                  ></v-select>
                </v-flex >
                <v-flex
                  xs1
                  style="padding: 8px">
                </v-flex>

                <v-flex xs11 style="padding: 8px">
                  <v-switch
                    v-model="counter.attributes.enabled"
                    label="Habilitar Counter"
                    color="primary"
                    hide-details
                  ></v-switch>
                </v-flex>

              </v-layout>
            </v-form>
          </v-flex>
        </v-layout>
      </div>
      <div class="table_card__footer">
        <button
          type="button"
          class="faccess_button"
          :disabled="saving || !counter.id"
          @click="saveChanges"
        >
          Guardar cambios
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data(){
    return{
      saving: false,
      counter: {
        attributes: {
          name:'',
          last_name: '',
          rut:'',
          email:'',
          location_id:null,
          company:this.getCompany().id,
          enabled:true
        }
      },
      locationArray:[],
      rules: {
        required: value => (value && String(value).length > 0) || 'Este campo es obligatorio',
        requiredSelect: value => (value !== null && value !== undefined && value !== '') || 'Este campo es obligatorio',
        name: value =>{
          if(!value){ return 'Este campo es obligatorio'}
          if(value.length>=3){
            return  value.length <= 25 || 'Máximo 25 caracteres'
          }else{
            return value.length >= 3  || 'Mínimo 3 caracteres'
          }},
        affair: value => !value || value.length <= 50 || 'Máximo 50 caracteres',
        email: value => {
          if(!value){ return 'Este campo es obligatorio'}
          if(value.length > 0) {
            const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return pattern.test(value) || 'E-mail incorrecto';
          }
        },
        rut: value => {
          if(!value){ return 'Este campo es obligatorio'}
          if(value.length >20){return 'El rut no debe tener más de 20 caracteres' }
          else if(value.length > 6) {return !isNaN(value.substring(0,value.length-1)) || 'Formato de Rut incorrecto'}
          else{return 'El Rut debe tener al menos 7 caracteres'}},
      },
      valid: false
    }
  },
  created() {
    const companyPayload = { company: { id: this.getCompany().id } }
    const headers = {
      'X-Device-ID': this.getDeviceId(),
      Authorization: 'Bearer ' + this.getUserToken()
    }

    const applyFromCounterPayload = (payload) => {
      if (!payload || !payload.attributes) return
      const loc = payload.attributes.location
      const locId =
        loc && loc.id !== undefined && loc.id !== null
          ? loc.id
          : null
      this.counter = {
        id: payload.id,
        attributes: {
          name: payload.attributes.name || '',
          last_name: payload.attributes.last_name || '',
          rut: (payload.attributes.user && payload.attributes.user.rut) ? payload.attributes.user.rut : '',
          email: (payload.attributes.user && payload.attributes.user.email) ? payload.attributes.user.email : '',
          location_id: this.normalizeLocationId(locId),
          company: this.getCompany().id,
          enabled: payload.attributes.enabled !== false
        }
      }
    }

    this.fetchAllLocations(companyPayload, headers)
      .then((response) => {
        const itemFromRoute = this.$route.params.counter
        if (itemFromRoute && itemFromRoute.attributes) {
          applyFromCounterPayload(itemFromRoute)
          return null
        }
        const counterId = this.$route.params.id
        if (!counterId) {
          return null
        }
        return this.$http.get(`counters/${counterId}`, { headers })
      })
      .then((response) => {
        if (response && response.body && response.body.data) {
          applyFromCounterPayload(response.body.data)
        }
        if (response && response.body && response.body.meta && response.body.meta.authentication_token) {
          this.checkToken(response.body.meta.authentication_token)
        }
      })
      .catch((err) => {
        console.error(err)
        alert('No se pudieron cargar locaciones o el counter. Recarga la página o vuelve al listado.')
      })
  },
  methods: {
    fetchAllLocations(companyPayload, headers) {
      const allLocations = []
      const loadPage = (page) => {
        return this.$http
          .post('locations/company', { data: this.encrypt(companyPayload).toString() }, {
            headers,
            params: { page }
          })
          .then((response) => {
            const body = response.body || {}
            const locations = body.data || []
            const meta = body.meta || {}
            const totalPages = Number(meta.pages || 1)
            allLocations.push(...locations)
            if (meta.authentication_token) {
              this.checkToken(meta.authentication_token)
            }
            if (page < totalPages) {
              return loadPage(page + 1)
            }
            this.locationArray = allLocations.map((elem) => ({
              id: this.normalizeLocationId(elem.id),
              name: elem.attributes.name
            }))
          })
      }

      return loadPage(1)
    },
    normalizeLocationId(raw) {
      if (raw === null || raw === undefined || raw === '') return null
      const n = Number(raw)
      return Number.isNaN(n) ? raw : n
    },
    isRutValid(evt){
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46 && evt.key.toUpperCase()!="K") {
        evt.preventDefault();;
      } else {
        return true;
      }
    },
    saveChanges() {
      if (!this.counter.id) {
        alert('No se encontró el identificador del counter.')
        return
      }
      if (this.$refs.form && this.$refs.form.validate && !this.$refs.form.validate()) {
        return
      }

      String.prototype.capitalize = function() {
        return this.replace(/(?:^|\s)\S/g, function(a) { return a.toUpperCase(); })
      }
      this.counter.attributes.name = this.counter.attributes.name.capitalize()
      this.counter.attributes.last_name = this.counter.attributes.last_name.capitalize()
      this.counter.attributes.rut = this.counter.attributes.rut.toUpperCase()

      this.saving = true
      const headers = {
        'X-Device-ID': this.getDeviceId(),
        Authorization: 'Bearer ' + this.getUserToken()
      }
      const payload = {
        id: this.counter.id,
        attributes: this.counter.attributes
      }

      this.$http
        .patch(`counters/${this.counter.id}`, { data: this.encrypt(payload).toString() }, { headers })
        .then((response) => {
          if (response.body.meta && response.body.meta.authentication_token) {
            this.checkToken(response.body.meta.authentication_token)
          }
          this.$router.push({ name: 'counter_index' })
        })
        .catch((response) => {
          if (response.body && response.body.meta && response.body.meta.authentication_token) {
            this.checkToken(response.body.meta.authentication_token)
          }
          if (response.body && response.body.errors && response.body.errors[0]) {
            const err = response.body.errors[0]
            if (typeof err.details !== 'object') {
              alert(err.details || err.title || 'Error al guardar')
            } else {
              const message = []
              for (var key in err.details) {
                message.push(err.details[key])
              }
              alert(message.join('\n'))
            }
          } else {
            alert('Error al guardar los cambios')
          }
        })
        .then(() => { this.saving = false }, () => { this.saving = false })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/access/counter/EditCounter.vue